import "core-js/modules/es.array.concat.js";
import { request } from '@/api/index';
import { api3 } from '@api/env';
export function getControlList(params) {
  return request({
    baseURL: api3,
    url: '/api/Tasks/all/confirmControls',
    method: 'get',
    params: params,
    getHeaders: true,
    customWithCredentials: false
  });
}
export function getControlListFormTask(params, taskId) {
  return request({
    baseURL: api3,
    url: "/api/Tasks/".concat(taskId, "/confirmControls"),
    method: 'get',
    params: params,
    getHeaders: true
  });
}
export function getControlListItems(taskId, controlId, params) {
  return request({
    baseURL: api3,
    url: "/api/Tasks/".concat(taskId, "/confirmControls/").concat(controlId),
    method: 'get',
    params: params
  });
}
export function toExport2Excel(id, params) {
  return request({
    baseURL: api3,
    url: "/api/Tasks/".concat(id, "/listConfrimations"),
    method: 'get',
    params: params,
    customWithCredentials: false
  });
}